// Config for the development-environment only

/** Ports for the development server */
export const APP_PORTS: Record<ImportMetaEnv["VITE_APP"], number> = {
  global: 3000,
  organization: 3001,
};
